import service from '@/api/patientProfile';
import {loading, alert, handleError} from '@/state/generators/helpers';

const DISMISSED_KEY_PREFIX = 'onboardingDismissed:';

export const state = {
    loading: false,
    service: service('patient/me/profile'),
    profile: null,
    loaded: false,
    errors: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    profile: function (state) {
        return state.profile ? JSON.parse(JSON.stringify(state.profile)) : null;
    },
    loaded: function (state) {
        return !!state.loaded;
    },

    needsOnboarding: function (state, getters, rootState, rootGetters) {
        if (!state.loaded || !state.profile) {
            return false;
        }

        const userId = rootGetters['auth/user']?.id;

        if (userId && localStorage.getItem(DISMISSED_KEY_PREFIX + userId)) {
            return false;
        }

        return !state.profile.biological_sex && !state.profile.health_goal;
    },

    states: function (state) {
        const states = {};

        Object.keys(state.errors || {}).forEach(key => {
            states[key] = false;
        });

        return states;
    },

    errors: function (state) {
        const errors = Object.assign({}, (state.errors || {}));

        Object.keys(errors).forEach(key => {
            errors[key] = Array.isArray(errors[key]) ? errors[key].join(' ') : String(errors[key]);
        });

        return errors;
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_PROFILE': function (state, profile = null) {
        state.profile = profile;
    },
    'SET_LOADED': function (state, boolean = true) {
        state.loaded = boolean;
    },
    'SET_ERRORS': function (state, errors = {}) {
        state.errors = errors;
    }
};

export const actions = {
    show: function ({commit, state}) {
        loading(commit);

        return state.service.fetchProfile().then(response => {
            commit('SET_PROFILE', response.data);
            commit('SET_LOADED', true);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    update: function ({commit, state}, payload) {
        loading(commit);

        return state.service.updateProfile(payload).then(response => {
            commit('SET_PROFILE', response.data);
            commit('SET_LOADED', true);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    dismissOnboarding: function ({rootGetters}) {
        const userId = rootGetters['auth/user']?.id;

        if (userId) {
            localStorage.setItem(DISMISSED_KEY_PREFIX + userId, new Date().toISOString());
        }
    },

    clearModule: function ({commit}) {
        commit('SET_PROFILE', null);
        commit('SET_LOADED', false);
        commit('SET_ERRORS', {});
    }
};
